<h2 class="instruction-title">Bevor du loslegst ...</h2>

<p>Hier ein paar wichtige Hinweise:</p>

<ul>
  <li><strong>Kein Medizinprodukt</strong></li>
  <li><strong>Kein Ersatz</strong> für ärztliche oder therapeutische Konsultation</li>
  <li><strong>Keine Diagnosestellung</strong></li>
</ul>

<p>Diese App unterstützt dich, ersetzt jedoch keine medizinische oder therapeutische Beratung.</p>
